import script from "./Amount.vue?vue&type=script&setup=true&lang=js"
export * from "./Amount.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__